import { useState } from "react";
import { Header } from "../components/Header";
import { HomeSections } from "../components/HomeSections";
import { WebinarSection } from "../components/WebinarSection";
import { FAQSection } from "../components/FAQSection";
import { ContactSection } from "../components/ContactSection";
import { BackOfficeSection } from "../components/BackOfficeSection";
import { Footer } from "../components/Footer";
import { InfoRequestModal } from "../components/InfoRequestModal";

export default function MainPage() {
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const handleInfoClick = () => setInfoModalOpen(true);

  return (
    <div className="min-h-screen overflow-x-hidden">
      <Header onOrderClick={handleInfoClick} />
      <HomeSections onOrderClick={handleInfoClick} onInfoClick={handleInfoClick} />
      <WebinarSection onOrderClick={handleInfoClick} />
      <FAQSection />
      <ContactSection />
      <BackOfficeSection />
      <Footer />
      <InfoRequestModal open={infoModalOpen} onOpenChange={setInfoModalOpen} />
    </div>
  );
}
